import React from "react";
import classes from "./DiamondQualityTooltip.module.css";
import igiLogo from "../../Utils/images/igiLogoImage.png"
const DiamondQualityTooltip = () => {
  const diamondData = [
    {
      title:     "Natural Diamonds",
      qualities: [
        { label: "Good", value: "HI/I2" },
        { label: "Better", value: "HI/I1", highlight: true },
        { label: "Best", value: "GH/SI" },
      ],
    },
    {
      title:     "Lab-grown Diamonds",
      qualities: [
        { label: "Good", value: "GH/SI" },
        { label: "Better", value: "EF/VS", highlight: true },
        { label: "Best", value: "DE/VVS" },
      ],
    },
  ];

  return (
    <><div className={classes.diamondQualityBody}>
      <p className={classes.introText}>
        Availability varies between natural and lab-grown diamonds. Here’s how
        we categorize quality for each:
      </p>

      <div className={classes.tableGrid}>
        {diamondData.map(({ title, qualities }) => (
          <div key={title} className={classes.tableColumn}>
            <div className={classes.tableHeader}>
              <h2 className={classes.headerTitle}>{title}</h2>
            </div>
            <div className={classes.tableContent}>
              {qualities.map(({ label, value, highlight }) => (
                <div
                  key={label}
                  className={
                    highlight ? classes.tableRowBetter : classes.tableRow
                  }
                >
                  <span className={classes.qualityLabel}>{label}</span>
                  <span className={classes.qualityValue}>{value}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
        </div>
      </div>
      <div className={classes.igiSection}>
        <div className={classes.igiLogoWrapper}>
          <img
            src={igiLogo}
            alt="IGI Certification Logo"
            className={classes.igiLogo}
          />
        </div>
        <div className={classes.igiTextWrapper}>
          <p className={classes.igiText}>
            Each pair of earrings includes an IGI (International Gemological Institute)
            evaluation report, offering independent verification of the diamonds' 4Cs cut,
            color, clarity, and carat weight. This ensures every stone meets the highest
            quality standards.
          </p>
        </div>
      </div>
      <div className={classes.learnMore}>
        <p className={classes.learnMoreText}>
          To learn more, check out{" "}
          <a href="https://www.helzberg.com/jewelry-advice/the-4cs-of-diamonds.html" target="_blank" className={classes.learnMoreLink}>
            The 4 c’s of Diamonds
          </a>.
        </p>
      </div>

    </>
  )
    ;
};

export default DiamondQualityTooltip;
